import { Directive, DirectiveBinding } from "vue";

import { useUserStoreHook } from "@/store/modules/user";

/**
 * 按钮权限
 */
export const hasPerm: Directive = {
  mounted(el: HTMLElement, binding: DirectiveBinding) {
    const { roles, perms } = useUserStoreHook();
    // 「超级管理员」拥有所有的按钮权限 1 -> 超级管理员
    if (Object.values(roles).includes(1)) {
      return true;
    }
    // 「其他角色」按钮权限校验
    const { value } = binding;
    if (value) {
      const requiredPerms = value; // DOM绑定需要的按钮权限标识

      const hasPerm = perms?.some((perm) => {
        return requiredPerms.includes(perm);
      });

      if (!hasPerm) {
        el.parentNode && el.parentNode.removeChild(el);
      }
    } else {
      // 不传就显示
      // throw new Error("暂未授权");
    }
  },
};
